import { useEffect } from 'react';
import useMergedState from './useMergedState';
import { inspectionDB } from '../data/database.structure';
import { inspectionService } from '../services/inspection/inspection.service';
import { set } from 'date-fns';

interface InitialDataLoadedState {
  isInitialDataLoaded: boolean;
  isLoading: boolean;
  error?: string;
}

export const useInitialDataLoaded = () => {
  const [initialDataLoadedState, setinitialDataLoadedState] =
    useMergedState<InitialDataLoadedState>({
      isInitialDataLoaded: false,
      isLoading: true,
      error: undefined,
    });

  useEffect(() => {
    const initialDataHandler = async () => {
      const hasLastSyncDate = localStorage.getItem('lastSyncDate');
      if (hasLastSyncDate) {
        // If the lastSyncDate exists, check the database for some data before confirming initial data load
        try {
          const assetsCount = await inspectionDB.assets.count();
          if (assetsCount === 0) {
            // If there are no assets, we assume the initial data is not loaded
            // Forget the last sync to trigger the initial data load again
            inspectionService.clearSyncState();

            // Delete all databases in indexedDB that start with 'inspect_db_' - except for the current one
            const dbNames = await indexedDB.databases();
            dbNames.forEach((db) => {
              if (db.name === undefined) {
                throw new Error('IndexedDB database name is undefined');
              }
              if (
                db.name.startsWith('inspect_db_') &&
                db.name !== inspectionDB.name
              ) {
                indexedDB.deleteDatabase(db.name);
                console.log(`Deleted IndexedDB database: ${db.name}`);
              }
            });

            window.location.reload();
            return;
          }
          setinitialDataLoadedState({
            isInitialDataLoaded: true,
            isLoading: false,
          });
        } catch (error) {
          console.error('Error checking initial data:', error);
          setinitialDataLoadedState({
            isLoading: false,
            error: 'Failed to load initial data',
          });
        }
      } else {
        setinitialDataLoadedState({ isLoading: false });
      }
    };

    initialDataHandler();
  }, []);

  return initialDataLoadedState;
};
